import { render, staticRenderFns } from "./RelatorioLogPerfil.vue?vue&type=template&id=467fedc8&scoped=true"
import script from "./RelatorioLogPerfil.vue?vue&type=script&lang=js"
export * from "./RelatorioLogPerfil.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogPerfil.vue?vue&type=style&index=0&id=467fedc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467fedc8",
  null
  
)

export default component.exports